@if (true) {
<form [formGroup]="form" (ngSubmit)="submitForm()">

  <!-- CARD -->
  <div class="card">
    <div class="card-body">

      <div class="row">

        @for (input of formData; track input.controlName) {

          @switch (input.controlType) {

            <!-- HIDDEN -->
            @case ('Hidden') {
              <input
                type="hidden"
                [formControlName]="input.controlName"
              />
            }

            <!-- TEXT -->
            @case ('TXT') {
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label
                    class="form-label"
                    [for]="input.controlName">
                    {{ input.captionName }} 
                    @if (input.validators?.required) {
                      <span style="color:red;">*</span>
                    }
                  </label>

                  <input
                    class="form-control"
                    type="text"
                    [id]="input.controlName"
                    [formControlName]="input.controlName"
                    [placeholder]="input.placeholder || 'Enter ' + input.captionName"
                  />

                  @if (
                    form.get(input.controlName)?.invalid &&
                    (form.get(input.controlName)?.dirty ||
                     form.get(input.controlName)?.touched)
                  ) {
                    <div class="text-danger small mt-1">
                      @if (form.get(input.controlName)?.errors?.['required']) {
                        {{ input.captionName }} is required
                      }
                      @if (form.get(input.controlName)?.errors?.['minlength']) {
                        Minimum length is {{ input.validators.minlength }}
                      }
                    </div>
                  }
                </div>
              </div>
            }

            <!-- DROPDOWN (HLP) -->
            @case ('HLP') {
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label
                    class="form-label"
                    [for]="input.controlName">
                    {{ input.captionName }} 
                    @if (input.validators?.required) {
                      <span style="color:red;">*</span>
                    }
                  </label>

                  <ng-select
                    [items]="input.Options"
                    bindLabel="optionName"
                    bindValue="value"
                    [formControlName]="input.controlName"
                    [placeholder]="input.placeholder || 'Select ' + input.captionName"
                    [clearable]="false">

                    <ng-option
                      *ngIf="!input.Options?.length"
                      [value]="''">
                      {{ input.placeholder || 'Select option' }}
                    </ng-option>

                  </ng-select>
                    @if (
                      form.get(input.controlName)?.invalid &&
                      (form.get(input.controlName)?.touched ||
                      form.get(input.controlName)?.dirty)
                    ) {
                      <div class="text-danger small mt-1">

                        @if (form.get(input.controlName)?.errors?.['required']) {
                          {{ input.captionName }} is required
                        }

                        @if (form.get(input.controlName)?.errors?.['requiredTrue']) {
                          You must accept {{ input.captionName }}
                        }

                        @if (form.get(input.controlName)?.errors?.['minlength']) {
                          Minimum length is {{ input.validators?.minlength }}
                        }

                        @if (form.get(input.controlName)?.errors?.['maxlength']) {
                          Maximum length is {{ input.validators?.maxlength }}
                        }

                        @if (form.get(input.controlName)?.errors?.['pattern']) {
                          Invalid {{ input.captionName }} format
                        }

                      </div>
                    }
                </div>
              </div>
            }

            <!-- CHECKBOX -->
            @case ('CHK') {
              <div class="col-12 col-md-6">
                <div class="form-group d-flex align-items-center gap-2 mt-4">
                  <input
                    type="checkbox"
                    [formControlName]="input.controlName"
                  />
                  <label class="form-check-label mb-0">
                    {{ input.captionName }}
                  </label>
                </div>
              </div>
            }

          }
        }

      </div>
    </div>
  </div>

  <!-- FOOTER / ACTIONS -->

    <div class="d-flex justify-content-center mt-3">
        <button class="btn btn-primary submit-btn small" type="submit">
            {{ buttonName }}
        </button>
    </div>

</form>

} @else {
    <!-- <form [formGroup]="form" class="modal-body  col-sm-12 form-group" (submit)="submitForm()">
        <ng-template ngFor let-input [ngForOf]="formData">
            <ng-container [ngSwitch]="input.controlType">
                <ng-template [ngSwitchCase]="'Hidden'">
                    <div style="display:none;" class="form-group">
    
                        <input class="form-control" [formControlName]="input.controlName" type="hidden" [value]="input.selectedValue" />
    
                    </div>
                </ng-template>
                <ng-template [ngSwitchCase]="'TXT'">
                    <br><br>
                    <div class="form-group">
    
                        <label class="col-sm-3" [for]="input.controlName"> {{input.captionName}}</label>
                        <input class="col-sm-6 form-control" [formControlName]="input.controlName" type="text" [value]="input.selectedValue" [name]="input.controlName" [required]="input.validators.required" [minlength]="input.validators.minlength" [maxlength]="input.validators.maxlength"
                        />
                        <div class="col-sm-3 error" *ngIf="form.get(input.controlName).invalid && (form.get(input.controlName).dirty || form.get(input.controlName).touched)">
                            <div *ngIf="form.get(input.controlName).errors.required">
                                Input required
                            </div>
                            <div *ngIf="form.get(input.controlName).errors.minlength">
                                Minimum length is {{input.validators.minlength}}
                            </div>
                        </div>
                    </div>
                </ng-template>
    
                <ng-template [ngSwitchCase]="'HLP'">
                    <br><br>
                    <div class="form-group">
                        <label class="col-sm-3" [for]="input.controlName"> {{input.captionName}}</label>
                        <select class="col-sm-6 form-control" [formControlName]="input.controlName" [value]="input.selectedValue" [name]="input.controlName" [id]="input.controlName" [required]="input.validators.required">
                  <option value="0">{{input.placeholder}}</option>
                  <option *ngFor="let option of input.Options" [value]="option.value">{{option.optionName}}</option>       </select>
                        <div class="col-sm-3">&nbsp;</div>
                    </div>
                </ng-template>
    
                <ng-template [ngSwitchCase]="'CHK'">
                    <br><br>
                    <div class="form-group">
                        <label class="col-sm-3"> {{input.captionName}}</label>
                        <input class="col-sm-1 " type="checkbox" [checked]="input.selectedValue" [formControlName]="input.controlName" />
                        <div class="col-sm-8">&nbsp;</div>
                    </div>
                </ng-template>
            </ng-container>
        </ng-template>
        <div><br><br>
            <div class="form-group">
                <div class="col-sm-3">&nbsp;</div>
                <input class="btn btn-primary col-sm-3" type="submit" value={{buttonName}}>
                <div class="col-sm-6"></div>
            </div>
        </div>
    
    </form> -->
}